import { Navigate, Outlet } from 'react-router-dom'
import { isAuthorizedUser } from '../../lib/apiFetch'

/**
 * UI-only route guard. Renders nested routes for authorized users; everyone else
 * is bounced to the public /auto-test page (the one feature open to all). Used as a
 * pathless layout route so protection is the DEFAULT — any new route placed inside
 * is guarded automatically, and only explicitly-public routes sit outside it.
 *
 * Not real authorization: the server enforces auth on every /api/* call. Reading
 * the in-memory user at render is safe because verifyToken() resolves it before
 * view === 'app' renders, and any 401 forces a full reload.
 */
export function ProtectedRoute() {
  return isAuthorizedUser() ? <Outlet /> : <Navigate to="/auto-test" replace />
}
